module.exports = __webpack_public_path__ + "img/customer-icon-6.130aeb4c.png";